import isEmpty from 'lodash-es/isEmpty'

export const isEmptyObject = <T extends Record<string, unknown>>(object: T) =>
  isEmpty(object)
